import React from 'react';
import {Modal} from 'react-native';

import {Container, VideoContainer} from './styles';

interface Params {
  videoURI: string;
  onVideoEnd: () => void;
}

export function HelpVideo({videoURI, onVideoEnd}: Params) {
  return (
    <Modal visible transparent animationType="fade" statusBarTranslucent>
      <Container activeOpacity={1}>
        <VideoContainer
          source={{uri: videoURI}}
          resizeMode="contain"
          onEnd={onVideoEnd}
          onBack={onVideoEnd}
        />
      </Container>
    </Modal>
  );
}
